<h2 mat-dialog-title>Modifica Mittenti associati a Utente</h2>
<hr>
<form [formGroup]="modifyUserSendersForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="container" id="modify-container">
        <div class="container min-height">
            <h4 class="list-title left">Disponibili</h4>
            <div class="list-container left">
                <ng-container *ngFor="let item of availableSenders;">
                    <span *ngIf="!item.selected;" (click)="onItemClick(item)" class="unselectable"
                        [class.chosen]="item.chosen">
                        {{ item.nameSender }}</span>
                </ng-container>
            </div>
            <button mat-stroked-button class="add-remove-button" type="button" (click)="onSwitchClick()">
                <mat-icon [inline]="true" style="color: grey;">swap_horiz</mat-icon>
            </button>
            <h4 class="list-title right">Selezionate</h4>
            <div class="list-container right">
                <ng-container *ngFor="let item of availableSenders;">
                    <span *ngIf="item.selected;" (click)="onItemClick(item)" class="unselectable"
                        [class.chosen]="item.chosen">
                        {{ item.nameSender }}</span>
                </ng-container>
            </div>
            <!-- <button mat-flat-button aria-label="Edit sender button" class="save-button"
                (click)="saveCategoriesButtonClick()" type="button" matTooltip="Salva categorie"
                [matTooltipShowDelay]="600">
                <mat-icon>save</mat-icon>
            </button> -->
        </div>
    </mat-dialog-content>
    <hr>
    <mat-dialog-actions id="action-div">
        <button mat-stroked-button (click)="closeCancelling()" type="button" cdkFocusInitial>Annulla</button>
        <button mat-stroked-button color="primary" type="submit" [disabled]="!modifyUserSendersForm.valid">Modifica</button>
    </mat-dialog-actions>
</form>